import { render } from "./questions-page.vue?vue&type=template&id=378c1f86&scoped=true"
import script from "./questions-page.vue?vue&type=script&lang=js"
export * from "./questions-page.vue?vue&type=script&lang=js"

import "./questions-page.vue?vue&type=style&index=0&id=378c1f86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378c1f86"]])

export default __exports__